// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"bb59912d","724":"f6ab039d"}[chunkId] + ".chunk.js";
};